import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SellApartmentFlowPaths } from 'routes';
import useApartmentSaleInfo from 'api/hooks/use-apartment-sale-info';
import useBoundStore from 'store';
import Loader from 'components/loader';
import NotFound from 'components/not-found';
import TextInput from 'components/text-input';
import BaseScreen from 'components/base-screen';
import { ButtonProps } from 'components/button';
import styles from './styles.module.scss';
import NumberInput from '../../components/number-input';
import { Select } from '../../components/select';
import useNotificationGeneralFilterLimit from '../../hooks/use-notification-general-limin';
import { transformTypeFacility } from '../../lib/utils';

const SellChooseApartmentSecondary: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const facilityCount = location?.state?.facilityCount;

  const selectedSellBuildingSecondary = useBoundStore((s) => s.selectedSellBuildingSecondary);
  const typeId = useBoundStore((s) => s.typeIdSecondary);
  const setSellApartmentNumberSecondary = useBoundStore((s) => s.setSellApartmentNumberSecondary);
  const setSellAreaInSqMSecondary = useBoundStore((s) => s.setSellAreaInSqMSecondary);
  const setTypeIdSecondary = useBoundStore((s) => s.setTypeIdSecondary);

  const [errorMessage, setErrorMessage] = useState('');
  const [errorApartmentMessage, setErrorApartmentMessage] = useState('');
  const [apartmentNumber, setApartmentNumber] = useState('');
  const { apartmentSellInfo, isLoading, error } = useApartmentSaleInfo(
    selectedSellBuildingSecondary.id,
    apartmentNumber,
  );
  const [areaInSqM, setAreaInSqM] = useState(`${apartmentSellInfo?.areaInSqM ?? ''}`);
  const canProceed = apartmentNumber && !!typeId && !errorMessage && !errorApartmentMessage;

  useEffect(() => {
    setAreaInSqM(`${apartmentSellInfo?.areaInSqM || 0}`);
  }, [apartmentSellInfo?.typeId, apartmentSellInfo?.areaInSqM]);

  const limits = useNotificationGeneralFilterLimit();

  useEffect(() => {
    if (+apartmentNumber > facilityCount) {
      setErrorApartmentMessage(
        `Номер квартиры не может превышать максимального количества квартир в доме (${
          facilityCount ?? '-'
        })`,
      );
    }
  }, [isLoading]);

  useEffect(() => {
    return () => setErrorMessage('');
  }, []);

  const buttons: ButtonProps[] = [
    {
      label: 'Продолжить',
      disabled: !canProceed,
      variant: 'secondary',
      onClick: () => {
        setSellApartmentNumberSecondary(apartmentNumber);
        setSellAreaInSqMSecondary(areaInSqM);
        // setSellRoomCountSecondary(roomCount);
        setTypeIdSecondary(typeId);
        navigate(SellApartmentFlowPaths.priceSecondaryScreen);
      },
    },
  ];

  const validateApartmentCount = (value: string) => {
    if (+value > facilityCount) {
      setErrorApartmentMessage(
        `Номер квартиры не может превышать максимального количества квартир в доме (${
          facilityCount ?? '-'
        })`,
      );
    }
  };

  const handleSetApartmentNumber = (value: any) => {
    if (+value < facilityCount) {
      setErrorApartmentMessage('');
      setAreaInSqM('');
    }
    setApartmentNumber(value);
  };

  const transformedTypes = !!limits?.facilityTypes?.length
    ? transformTypeFacility(limits?.facilityTypes)?.map((i) => ({
        id: i.id,
        key: i.id,
        label: i.fullTitle,
      }))
    : [];

  return (
    <BaseScreen
      padContent
      title='Выберите квартиру'
      buttons={buttons}
      onBackButtonClick={() => navigate(-1)}
      floatingButtons={false}
    >
      <div className={styles.complex}>Дом</div>

      <div className={styles.inputsContainer}>
        <TextInput tall value={selectedSellBuildingSecondary.title} disabled />
        <TextInput
          tall
          value={apartmentNumber}
          placeholder='Введите номер квартиры'
          label='Номер квартиры'
          onChange={handleSetApartmentNumber}
          onBlur={(value) => validateApartmentCount(value.target.value)}
          error={errorApartmentMessage}
          clearButton
          onClean={() => setErrorApartmentMessage('')}
        />
      </div>

      <div className={styles.apartmentInfo}>
        {isLoading ? (
          <Loader size={40} />
        ) : !errorApartmentMessage ? (
          <div className={styles.inputsContainer}>
            <p className={styles.label}>Тип квартиры</p>
            <Select
              onSelect={(value: number) => {
                setTypeIdSecondary(value);
              }}
              selected={typeId}
              className={styles.priceInput}
              multiple={false}
              menuArray={transformedTypes}
            />
            <p className={styles.label}>Площадь</p>
            <NumberInput
              value={areaInSqM}
              onChange={(value: any) => setAreaInSqM(value.replace(/[^\d.]/g, ''))}
              sign='м2'
              className={styles.priceInput}
              IsDisabledClearButton={true}
            />
          </div>
        ) : error ? (
          <NotFound message={error} />
        ) : null}
      </div>
    </BaseScreen>
  );
};

export default SellChooseApartmentSecondary;
